import { render, staticRenderFns } from "./CollectionStyle.vue?vue&type=template&id=19feae56&name=collection-style&"
import script from "./CollectionStyle.vue?vue&type=script&lang=js&"
export * from "./CollectionStyle.vue?vue&type=script&lang=js&"
import style0 from "./CollectionStyle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports